import axios from "axios";
import { authHeader } from "../../authServices/auth.header";
import { setServiceProviders } from "@/helpers/BatchService.js";

const API_URL = process.env.VUE_APP_ROOT_API;
// Get Device Profile List
class SeviceProvider {
  // Get Service Provider List
  async getServiceProviderList(filter = "") {
    return await axios
      .get(API_URL + "phone-service/service-provider" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get destination details
  async getServiceProviderDetail(service_pro_id) {
    return await axios
      .get(API_URL + `phone-service/service-provider?id=${service_pro_id}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // add new destination details
  async addServiceProvider(data) {
    return await axios
      .post(API_URL + "phone-service/service-provider", data, {
        headers: authHeader(),
      })
      .then((response) => {
        setServiceProviders();
        return response.data;
      });
  }
  // update destination details
  async updateServiceProvider(service_pro_id, data) {
    return await axios
      .patch(
        API_URL + "phone-service/service-provider/" + service_pro_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setServiceProviders();
        return response.data;
      });
  }
  // update destination details
  async putServiceProvider(pro_id, data) {
    return await axios
      .put(API_URL + `phone-service/service-provider/${pro_id}`, data, {
        headers: authHeader(),
      })
      .then((response) => {
        setServiceProviders();
        return response.data;
      });
  }
}

export default new SeviceProvider();
